export default function WaveBackground() {
  const circles = [
    { width: 900, left: -320, bottom: -660, right: undefined, top: undefined, opacity: 0.07 },
    { width: 1000, left: -360, bottom: -700, right: undefined, top: undefined, opacity: 0.06 },
    { width: 1100, left: -400, bottom: -740, right: undefined, top: undefined, opacity: 0.05 },
    { width: 900, left: undefined, bottom: undefined, right: -340, top: -560, opacity: 0.07 },
    { width: 1000, left: undefined, bottom: undefined, right: -380, top: -600, opacity: 0.06 },
  ];

  return (
    <div aria-hidden style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 0 }}>
      {circles.map((circle, index) => (
        <div
          key={index}
          style={{
            position: 'absolute',
            width: circle.width,
            height: circle.width,
            borderRadius: '50%',
            border: `2px solid rgba(59, 130, 246, ${circle.opacity})`,
            left: circle.left,
            bottom: circle.bottom,
            right: circle.right,
            top: circle.top,
          }}
        />
      ))}
    </div>
  );
}
